const trails_pt = require('./trails.json')
export default trails_pt